import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox } from "vue"

const _hoisted_1 = { class: "mx-2 mt-1" }
const _hoisted_2 = { class: "settings-tabbar-wrap" }
const _hoisted_3 = {
  class: "nav nav-tabs settings-tabbar",
  id: "myTabs",
  role: "tablist"
}
const _hoisted_4 = {
  class: "nav-item",
  role: "presentation"
}
const _hoisted_5 = {
  class: "nav-item",
  role: "presentation"
}
const _hoisted_6 = {
  class: "nav-item",
  role: "presentation"
}
const _hoisted_7 = {
  class: "nav-item",
  role: "presentation"
}
const _hoisted_8 = {
  class: "tab-content mt-3",
  id: "myTabContent"
}
const _hoisted_9 = {
  class: "tab-pane fade",
  role: "tabpanel",
  id: "ride-fees",
  "aria-labelledby": "ride-fees-tab"
}
const _hoisted_10 = {
  key: 0,
  class: "text-center py-4"
}
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { class: "row g-3" }
const _hoisted_13 = { class: "col-12 col-lg-6" }
const _hoisted_14 = { class: "settings-card" }
const _hoisted_15 = { class: "settings-card__header" }
const _hoisted_16 = { class: "settings-card__title" }
const _hoisted_17 = { class: "settings-card__body" }
const _hoisted_18 = { class: "row g-3" }
const _hoisted_19 = { class: "col-md-6" }
const _hoisted_20 = { class: "settings-field-label" }
const _hoisted_21 = { class: "settings-fee-field" }
const _hoisted_22 = ["disabled"]
const _hoisted_23 = ["disabled"]
const _hoisted_24 = { class: "col-md-6" }
const _hoisted_25 = { class: "settings-field-label" }
const _hoisted_26 = { class: "settings-fee-field" }
const _hoisted_27 = ["disabled"]
const _hoisted_28 = ["disabled"]
const _hoisted_29 = { class: "col-md-6" }
const _hoisted_30 = { class: "settings-field-label" }
const _hoisted_31 = { class: "settings-fee-field" }
const _hoisted_32 = ["disabled"]
const _hoisted_33 = ["disabled"]
const _hoisted_34 = { class: "col-md-6" }
const _hoisted_35 = { class: "settings-field-label" }
const _hoisted_36 = { class: "settings-fee-field" }
const _hoisted_37 = ["disabled"]
const _hoisted_38 = ["disabled"]
const _hoisted_39 = { class: "col-md-6" }
const _hoisted_40 = { class: "settings-field-label" }
const _hoisted_41 = { class: "settings-fee-field" }
const _hoisted_42 = { class: "col-md-6" }
const _hoisted_43 = { class: "settings-field-label" }
const _hoisted_44 = { class: "settings-fee-field" }
const _hoisted_45 = { class: "col-md-6" }
const _hoisted_46 = { class: "settings-field-label" }
const _hoisted_47 = { class: "settings-fee-field" }
const _hoisted_48 = ["disabled"]
const _hoisted_49 = ["disabled"]
const _hoisted_50 = { class: "col-md-6" }
const _hoisted_51 = { class: "settings-field-label" }
const _hoisted_52 = { class: "settings-fee-field" }
const _hoisted_53 = ["disabled"]
const _hoisted_54 = ["disabled"]
const _hoisted_55 = { class: "col-12" }
const _hoisted_56 = { class: "settings-field-label" }
const _hoisted_57 = { class: "settings-fee-field" }
const _hoisted_58 = ["disabled"]
const _hoisted_59 = ["disabled"]
const _hoisted_60 = { class: "mt-4 d-flex justify-content-end" }
const _hoisted_61 = ["disabled"]
const _hoisted_62 = {
  key: 0,
  class: "spinner-border spinner-border-sm",
  role: "status",
  "aria-hidden": "true"
}
const _hoisted_63 = { class: "col-12 col-lg-6" }
const _hoisted_64 = { class: "settings-card" }
const _hoisted_65 = { class: "settings-card__header" }
const _hoisted_66 = { class: "settings-card__title" }
const _hoisted_67 = { class: "settings-card__body" }
const _hoisted_68 = { class: "row g-3" }
const _hoisted_69 = { class: "col-md-6" }
const _hoisted_70 = { class: "settings-field-label" }
const _hoisted_71 = { class: "settings-fee-field" }
const _hoisted_72 = ["disabled"]
const _hoisted_73 = ["disabled"]
const _hoisted_74 = { class: "col-md-6" }
const _hoisted_75 = { class: "settings-field-label" }
const _hoisted_76 = { class: "settings-fee-field" }
const _hoisted_77 = ["disabled"]
const _hoisted_78 = ["disabled"]
const _hoisted_79 = { class: "col-md-6" }
const _hoisted_80 = { class: "settings-field-label" }
const _hoisted_81 = { class: "settings-fee-field" }
const _hoisted_82 = ["disabled"]
const _hoisted_83 = ["disabled"]
const _hoisted_84 = { class: "col-md-6" }
const _hoisted_85 = { class: "settings-field-label" }
const _hoisted_86 = { class: "settings-fee-field" }
const _hoisted_87 = ["disabled"]
const _hoisted_88 = ["disabled"]
const _hoisted_89 = { class: "mt-4 d-flex justify-content-end" }
const _hoisted_90 = ["disabled"]
const _hoisted_91 = {
  key: 0,
  class: "spinner-border spinner-border-sm",
  role: "status",
  "aria-hidden": "true"
}
const _hoisted_92 = { class: "col-12 col-lg-6" }
const _hoisted_93 = { class: "settings-card" }
const _hoisted_94 = { class: "settings-card__header" }
const _hoisted_95 = { class: "settings-card__title" }
const _hoisted_96 = { class: "settings-card__body" }
const _hoisted_97 = { class: "row g-3" }
const _hoisted_98 = { class: "col-12" }
const _hoisted_99 = { class: "settings-field-label" }
const _hoisted_100 = { class: "settings-fee-field" }
const _hoisted_101 = ["disabled"]
const _hoisted_102 = ["disabled"]
const _hoisted_103 = { class: "settings-monthly-hint" }
const _hoisted_104 = { class: "mt-4 d-flex justify-content-end" }
const _hoisted_105 = ["disabled"]
const _hoisted_106 = {
  key: 0,
  class: "spinner-border spinner-border-sm",
  role: "status",
  "aria-hidden": "true"
}
const _hoisted_107 = { class: "settings-card mt-3" }
const _hoisted_108 = { class: "settings-card__header" }
const _hoisted_109 = { class: "settings-card__title" }
const _hoisted_110 = {
  type: "button",
  class: "settings-primary-btn settings-header-action",
  "data-bs-toggle": "modal",
  "data-bs-target": "#multiplierModal"
}
const _hoisted_111 = { class: "settings-card__body" }
const _hoisted_112 = {
  key: 0,
  class: "settings-multiplier-list"
}
const _hoisted_113 = { class: "settings-multiplier-info" }
const _hoisted_114 = { class: "settings-multiplier-top" }
const _hoisted_115 = { class: "settings-multiplier-name" }
const _hoisted_116 = { class: "settings-multiplier-value" }
const _hoisted_117 = { class: "settings-multiplier-time" }
const _hoisted_118 = { class: "settings-field-label" }
const _hoisted_119 = ["onUpdate:modelValue"]
const _hoisted_120 = ["onUpdate:modelValue"]
const _hoisted_121 = ["onClick", "disabled"]
const _hoisted_122 = {
  key: 0,
  class: "spinner-border spinner-border-sm",
  role: "status",
  "aria-hidden": "true"
}
const _hoisted_123 = {
  key: 1,
  class: "fas fa-trash"
}
const _hoisted_124 = {
  class: "tab-pane fade",
  id: "messages",
  role: "tabpanel",
  "aria-labelledby": "messages-tab"
}
const _hoisted_125 = {
  class: "tab-pane fade",
  id: "monthly-payment-settings",
  role: "tabpanel",
  "aria-labelledby": "monthly-payment-settings-tab"
}
const _hoisted_126 = {
  key: 0,
  class: "text-center py-4"
}
const _hoisted_127 = {
  key: 1,
  class: "row"
}
const _hoisted_128 = { class: "col-12 col-lg-6" }
const _hoisted_129 = { class: "settings-card" }
const _hoisted_130 = { class: "settings-card__header" }
const _hoisted_131 = { class: "settings-card__title" }
const _hoisted_132 = { class: "settings-card__body" }
const _hoisted_133 = { class: "settings-monthly-subtitle" }
const _hoisted_134 = { class: "settings-monthly-field" }
const _hoisted_135 = { class: "settings-field-label" }
const _hoisted_136 = { class: "settings-fee-field" }
const _hoisted_137 = { class: "settings-monthly-field" }
const _hoisted_138 = { class: "settings-field-label" }
const _hoisted_139 = { class: "settings-fee-field" }
const _hoisted_140 = { class: "settings-monthly-hint" }
const _hoisted_141 = { class: "settings-monthly-field" }
const _hoisted_142 = { class: "settings-field-label" }
const _hoisted_143 = { class: "settings-fee-field" }
const _hoisted_144 = ["value"]
const _hoisted_145 = {
  key: 0,
  class: "settings-monthly-hint settings-monthly-hint--warning"
}
const _hoisted_146 = {
  key: 1,
  class: "settings-monthly-hint"
}
const _hoisted_147 = { class: "settings-monthly-toggle-panel" }
const _hoisted_148 = { class: "form-check form-switch settings-switch mb-0" }
const _hoisted_149 = { class: "settings-monthly-toggle-text" }
const _hoisted_150 = {
  class: "settings-monthly-toggle-label",
  for: "auto-disable-switch"
}
const _hoisted_151 = { class: "settings-monthly-hint" }
const _hoisted_152 = { class: "mt-4 d-flex justify-content-end" }
const _hoisted_153 = ["disabled"]
const _hoisted_154 = {
  key: 0,
  class: "spinner-border spinner-border-sm",
  role: "status",
  "aria-hidden": "true"
}
const _hoisted_155 = {
  class: "tab-pane fade show active settings-page",
  role: "tabpanel",
  id: "general_settings",
  "aria-labelledby": "settings-tab"
}
const _hoisted_156 = { class: "settings-card" }
const _hoisted_157 = { class: "settings-card__header" }
const _hoisted_158 = { class: "settings-card__title" }
const _hoisted_159 = { class: "settings-card__body" }
const _hoisted_160 = { class: "row" }
const _hoisted_161 = { class: "settings-branch-panel" }
const _hoisted_162 = { class: "settings-branch-panel__header" }
const _hoisted_163 = { class: "settings-branch-flag" }
const _hoisted_164 = {
  key: 1,
  class: "fas fa-flag"
}
const _hoisted_165 = { class: "settings-branch-info" }
const _hoisted_166 = { class: "settings-branch-country" }
const _hoisted_167 = { class: "settings-branch-meta" }
const _hoisted_168 = { class: "settings-branch-meta-item" }
const _hoisted_169 = { class: "settings-field-label" }
const _hoisted_170 = { class: "settings-branch-meta-value" }
const _hoisted_171 = { class: "settings-branch-meta-item" }
const _hoisted_172 = { class: "settings-field-label" }
const _hoisted_173 = { class: "settings-branch-meta-value" }
const _hoisted_174 = { class: "settings-field-label settings-cities-label" }
const _hoisted_175 = { class: "settings-cities-list" }
const _hoisted_176 = { class: "form-check form-switch settings-switch mb-0" }
const _hoisted_177 = ["onClick", "checked", "id"]
const _hoisted_178 = ["for"]
const _hoisted_179 = { class: "settings-city-pct" }
const _hoisted_180 = { class: "settings-city-pct-label" }
const _hoisted_181 = { class: "settings-city-pct-value" }
const _hoisted_182 = ["onClick"]
const _hoisted_183 = {
  class: "modal fade",
  id: "percentage-modal",
  tabindex: "-1",
  "aria-labelledby": "exampleModalLabel",
  "aria-hidden": "true"
}
const _hoisted_184 = {
  class: "modal-dialog modal-dialog-centered",
  role: "document"
}
const _hoisted_185 = { class: "modal-content" }
const _hoisted_186 = { class: "modal-header" }
const _hoisted_187 = {
  class: "modal-title",
  id: "exampleModalLabel"
}
const _hoisted_188 = { class: "modal-body" }
const _hoisted_189 = { class: "settings-monthly-field" }
const _hoisted_190 = { class: "settings-field-label" }
const _hoisted_191 = { class: "settings-modal-pct-value" }
const _hoisted_192 = { class: "settings-monthly-field" }
const _hoisted_193 = { class: "settings-field-label" }
const _hoisted_194 = { class: "modal-footer" }
const _hoisted_195 = {
  type: "button",
  class: "btn bg-gradient-secondary",
  "data-bs-dismiss": "modal"
}
const _hoisted_196 = ["disabled"]
const _hoisted_197 = {
  key: 0,
  class: "spinner-border spinner-border-sm",
  role: "status",
  "aria-hidden": "true"
}

import { ref, Ref } from 'vue'
import SettingsRepository from '@/repositories/SettingsRepository'
import MonthlyPaymentSettingsRepository from '@/repositories/MonthlyPaymentSettingsRepository'
import { MonthlyPaymentSettingsInterface } from '@/types/MonthlyPaymentSettingsInterface'
import SettingsMsg from '@/views/settings/messages/Index.vue'
import ToastService from '@/services/ToastService'
import i18n from '@/plugins/i18n'
import { Form } from 'vee-validate'
import {storeToRefs} from "pinia";
import {useSettingsStore} from "@/services/stores/SettingsStore";
import AuthService from '@/services/AuthService'
import { City } from '@/types/City'
import { Branch } from '@/types/Branch'
import CreateMultiplierModal from './CreateMultiplierModal.vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'SettingsApp',
  setup(__props) {

const settingsStore = useSettingsStore()
const { branches, branchSelected, rideFees, rideFeesLoading } = storeToRefs(settingsStore)
const { setBranchSelected, setPercentage } = settingsStore
const fieldEdited: Ref<string> = ref('')
const submitButtonEnabled: Ref<boolean> = ref(false)
const allFieldsDisabled: Ref<boolean> = ref(true);
const currentTab: Ref<string> = ref('general_settings')
let citySelected: Ref<City> = ref({} as City)
let branch: Ref<Branch> = ref({} as Branch)
const monthlyPaymentSettings: Ref<MonthlyPaymentSettingsInterface | null> = ref(null)
const reminderOffsetWarning = ref('')
const suggestedAmountInputEl = ref<HTMLInputElement | null>(null)
const cutoffDayInputEl = ref<HTMLInputElement | null>(null)
const reminderOffsetsInputEl = ref<HTMLInputElement | null>(null)
const updatingRideFees = ref(false)
const removingMultiplier = ref<Record<number, boolean>>({})
const submittingPercentage = ref(false)
const savingMonthlyPaymentSettings = ref(false)
const monthlyPaymentSettingsLoading = ref(false)

const COUNTRY_FLAGS: Record<string, string> = {
  colombia: '🇨🇴',
}

function countryFlag(country: string): string {
  return COUNTRY_FLAGS[country?.toLowerCase()] ?? ''
}

function resetRideFeesFormState(): void {
  fieldEdited.value = ''
  submitButtonEnabled.value = false
  allFieldsDisabled.value = true
}

async function handleRideFeesTabClick(): Promise<void> {
  currentTab.value = 'rideFees'

  try {
    await settingsStore.getRideFees()
    resetRideFeesFormState()
  } catch (e: unknown) {
    const message = e instanceof Error ? e.message : undefined
    await ToastService.toast(ToastService.ERROR, i18n.global.t('common.messages.error'), message)
  }
}

const editField = (fieldName: string) => {
  fieldEdited.value = fieldEdited.value === fieldName ? '' : fieldName
  submitButtonEnabled.value = true
  allFieldsDisabled.value = false
}

function selectBranch(b: Branch, city: City): void {
  citySelected.value = {
    ...city,
    location: { ...city.location },
    polygon: city.polygon.map((point) => ({ ...point })),
  }
  branch.value = b
}

function setPercentageModal(city: City, branchId: string): void {
  submittingPercentage.value = true
  setPercentage(branchId, city).catch(async e => {
    submittingPercentage.value = false
    await ToastService.toast(ToastService.ERROR, i18n.global.t('common.messages.error'), e.message)
  }).then(async () => {
    submittingPercentage.value = false
    await ToastService.toast(ToastService.SUCCESS, i18n.global.t('common.messages.updated'))
  })
}

function updateAllFields(): void {
  if (!rideFees.value) return

  updatingRideFees.value = true
  SettingsRepository.updateRideFee(rideFees.value).then(async () => {
    updatingRideFees.value = false
    resetRideFeesFormState()
    await ToastService.toast(ToastService.SUCCESS, i18n.global.t('common.messages.updated'))
  }).catch(async e => {
    updatingRideFees.value = false
    await ToastService.toast(ToastService.ERROR, i18n.global.t('common.messages.error'), e.message)
  })
}

function removeMultiplier(index: number): void {
  if (rideFees.value && rideFees.value.dynamic_multipliers) {
    removingMultiplier.value[index] = true
    SettingsRepository.removeMultiplier(rideFees.value.dynamic_multipliers, index).then(async () => {
      delete removingMultiplier.value[index]
      await ToastService.toast(ToastService.SUCCESS, i18n.global.t('common.messages.updated'))
    }).catch(async e => {
      delete removingMultiplier.value[index]
      await ToastService.toast(ToastService.ERROR, i18n.global.t('common.messages.error'), e.message)
    })
  }
}

function onReminderOffsetsChange(event: Event): void {
  const raw = (event.target as HTMLInputElement).value
  const parsed = raw.split(',').map(s => parseInt(s.trim(), 10)).filter(n => !isNaN(n) && n > 0)
  if (monthlyPaymentSettings.value) {
    monthlyPaymentSettings.value.reminder_offsets = parsed
  }
  checkReminderOffsetWarning()
}

function checkReminderOffsetWarning(): void {
  if (!monthlyPaymentSettings.value) return
  const cutoff = monthlyPaymentSettings.value.cutoff_day
  const unreachable = monthlyPaymentSettings.value.reminder_offsets.filter(o => cutoff - o < 1)
  reminderOffsetWarning.value = unreachable.length > 0
    ? i18n.global.t('settings.monthly_payments.warn_unreachable_offsets', { offsets: unreachable.join(', ') })
    : ''
}

async function handleMonthlyPaymentSettingsTabClick(): Promise<void> {
  currentTab.value = 'monthlyPaymentSettings'
  monthlyPaymentSettingsLoading.value = true
  try {
    monthlyPaymentSettings.value = await MonthlyPaymentSettingsRepository.get()
    checkReminderOffsetWarning()
  } catch (e: unknown) {
    const message = e instanceof Error ? e.message : undefined
    await ToastService.toast(ToastService.ERROR, i18n.global.t('common.messages.error'), message)
  } finally {
    monthlyPaymentSettingsLoading.value = false
  }
}

async function saveMonthlyPaymentSettings(): Promise<void> {
  if (!monthlyPaymentSettings.value) return
  savingMonthlyPaymentSettings.value = true
  try {
    monthlyPaymentSettings.value = await MonthlyPaymentSettingsRepository.save(monthlyPaymentSettings.value)
    await ToastService.toast(ToastService.SUCCESS, i18n.global.t('common.messages.updated'))
  } catch (e: unknown) {
    const message = e instanceof Error ? e.message : undefined
    await ToastService.toast(ToastService.ERROR, i18n.global.t('common.messages.error'), message)
  } finally {
    savingMonthlyPaymentSettings.value = false
  }
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("ul", _hoisted_3, [
        _createElementVNode("li", _hoisted_4, [
          _createElementVNode("button", {
            class: "nav-link settings-tab-link active",
            id: "settings-tab",
            "data-bs-toggle": "tab",
            "data-bs-target": "#general_settings",
            type: "button",
            role: "tab",
            "aria-controls": "settings",
            "aria-selected": "true",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (currentTab.value = 'general_settings'))
          }, [
            _cache[38] || (_cache[38] = _createElementVNode("em", { class: "fas fa-sliders" }, null, -1)),
            _createElementVNode("span", null, _toDisplayString(_ctx.$t('common.settings.general_settings')), 1)
          ])
        ]),
        _createElementVNode("li", _hoisted_5, [
          _createElementVNode("button", {
            class: "nav-link settings-tab-link",
            id: "ride-fees-tab",
            "data-bs-toggle": "tab",
            "data-bs-target": "#ride-fees",
            type: "button",
            role: "tab",
            "aria-controls": "ride-fees",
            "aria-selected": "false",
            onClick: handleRideFeesTabClick
          }, [
            _cache[39] || (_cache[39] = _createElementVNode("em", { class: "fas fa-dollar-sign" }, null, -1)),
            _createElementVNode("span", null, _toDisplayString(_ctx.$t('common.settings.Ride_Fees')), 1)
          ])
        ]),
        _createElementVNode("li", _hoisted_6, [
          _createElementVNode("button", {
            class: "nav-link settings-tab-link",
            id: "messages-tab",
            "data-bs-toggle": "tab",
            "data-bs-target": "#messages",
            type: "button",
            role: "tab",
            "aria-controls": "messages",
            "aria-selected": "false",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (currentTab.value = 'messages'))
          }, [
            _cache[40] || (_cache[40] = _createElementVNode("em", { class: "fas fa-envelope" }, null, -1)),
            _createElementVNode("span", null, _toDisplayString(_ctx.$t('common.settings.Messages')), 1)
          ])
        ]),
        _createElementVNode("li", _hoisted_7, [
          _createElementVNode("button", {
            class: "nav-link settings-tab-link",
            id: "monthly-payment-settings-tab",
            "data-bs-toggle": "tab",
            "data-bs-target": "#monthly-payment-settings",
            type: "button",
            role: "tab",
            "aria-controls": "monthly-payment-settings",
            "aria-selected": "false",
            onClick: handleMonthlyPaymentSettingsTabClick
          }, [
            _cache[41] || (_cache[41] = _createElementVNode("em", { class: "fas fa-calendar-check" }, null, -1)),
            _createElementVNode("span", null, _toDisplayString(_ctx.$t('settings.monthly_payments.tab_label')), 1)
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        (_unref(rideFeesLoading))
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [...(_cache[42] || (_cache[42] = [
              _createElementVNode("span", {
                class: "spinner-border",
                role: "status",
                "aria-hidden": "true"
              }, null, -1)
            ]))]))
          : (_openBlock(), _createElementBlock("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("div", _hoisted_14, [
                    _createElementVNode("div", _hoisted_15, [
                      _cache[43] || (_cache[43] = _createElementVNode("span", { class: "settings-icon-chip settings-icon-chip--success" }, [
                        _createElementVNode("em", { class: "fas fa-tags" })
                      ], -1)),
                      _createElementVNode("h6", _hoisted_16, _toDisplayString(_ctx.$t('common.settings.fees_base_title')), 1)
                    ]),
                    _createElementVNode("div", _hoisted_17, [
                      (_unref(rideFees))
                        ? (_openBlock(), _createBlock(_unref(Form), { key: 0 }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_18, [
                                _createElementVNode("div", _hoisted_19, [
                                  _createElementVNode("label", _hoisted_20, _toDisplayString(_ctx.$t('common.settings.price_kilometer')), 1),
                                  _createElementVNode("div", _hoisted_21, [
                                    _withDirectives(_createElementVNode("input", {
                                      type: "number",
                                      class: "settings-fee-input",
                                      disabled: fieldEdited.value !== 'price_kilometer' || allFieldsDisabled.value,
                                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(rideFees).price_kilometer) = $event))
                                    }, null, 8, _hoisted_22), [
                                      [_vModelText, _unref(rideFees).price_kilometer]
                                    ]),
                                    _createElementVNode("button", {
                                      type: "button",
                                      class: "settings-icon-btn",
                                      onClick: _cache[3] || (_cache[3] = ($event: any) => (editField('price_kilometer'))),
                                      disabled: fieldEdited.value === 'price_kilometer'
                                    }, [...(_cache[44] || (_cache[44] = [
                                      _createElementVNode("em", { class: "fas fa-pencil" }, null, -1)
                                    ]))], 8, _hoisted_23)
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_24, [
                                  _createElementVNode("label", _hoisted_25, _toDisplayString(_ctx.$t('common.settings.price_minute')), 1),
                                  _createElementVNode("div", _hoisted_26, [
                                    _withDirectives(_createElementVNode("input", {
                                      type: "number",
                                      class: "settings-fee-input",
                                      disabled: fieldEdited.value !== 'price_minute' || allFieldsDisabled.value,
                                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(rideFees).price_minute) = $event))
                                    }, null, 8, _hoisted_27), [
                                      [_vModelText, _unref(rideFees).price_minute]
                                    ]),
                                    _createElementVNode("button", {
                                      type: "button",
                                      class: "settings-icon-btn",
                                      onClick: _cache[5] || (_cache[5] = ($event: any) => (editField('price_minute'))),
                                      disabled: fieldEdited.value === 'price_minute'
                                    }, [...(_cache[45] || (_cache[45] = [
                                      _createElementVNode("em", { class: "fas fa-pencil" }, null, -1)
                                    ]))], 8, _hoisted_28)
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_29, [
                                  _createElementVNode("label", _hoisted_30, _toDisplayString(_ctx.$t('common.settings.fees_base')), 1),
                                  _createElementVNode("div", _hoisted_31, [
                                    _withDirectives(_createElementVNode("input", {
                                      type: "number",
                                      class: "settings-fee-input",
                                      disabled: fieldEdited.value !== 'fees_base' || allFieldsDisabled.value,
                                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(rideFees).fees_base) = $event))
                                    }, null, 8, _hoisted_32), [
                                      [_vModelText, _unref(rideFees).fees_base]
                                    ]),
                                    _createElementVNode("button", {
                                      type: "button",
                                      class: "settings-icon-btn",
                                      onClick: _cache[7] || (_cache[7] = ($event: any) => (editField('fees_base'))),
                                      disabled: fieldEdited.value === 'fees_base'
                                    }, [...(_cache[46] || (_cache[46] = [
                                      _createElementVNode("em", { class: "fas fa-pencil" }, null, -1)
                                    ]))], 8, _hoisted_33)
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_34, [
                                  _createElementVNode("label", _hoisted_35, _toDisplayString(_ctx.$t('common.settings.fees_additional')), 1),
                                  _createElementVNode("div", _hoisted_36, [
                                    _withDirectives(_createElementVNode("input", {
                                      type: "number",
                                      class: "settings-fee-input",
                                      disabled: fieldEdited.value !== 'fees_additional' || allFieldsDisabled.value,
                                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_unref(rideFees).fees_additional) = $event))
                                    }, null, 8, _hoisted_37), [
                                      [_vModelText, _unref(rideFees).fees_additional]
                                    ]),
                                    _createElementVNode("button", {
                                      type: "button",
                                      class: "settings-icon-btn",
                                      onClick: _cache[9] || (_cache[9] = ($event: any) => (editField('fees_additional'))),
                                      disabled: fieldEdited.value === 'fees_additional'
                                    }, [...(_cache[47] || (_cache[47] = [
                                      _createElementVNode("em", { class: "fas fa-pencil" }, null, -1)
                                    ]))], 8, _hoisted_38)
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_39, [
                                  _createElementVNode("label", _hoisted_40, _toDisplayString(_ctx.$t('common.settings.fees_minimum')), 1),
                                  _createElementVNode("div", _hoisted_41, [
                                    _withDirectives(_createElementVNode("input", {
                                      type: "number",
                                      class: "settings-fee-input",
                                      disabled: "",
                                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_unref(rideFees).fees_minimum) = $event))
                                    }, null, 512), [
                                      [_vModelText, _unref(rideFees).fees_minimum]
                                    ]),
                                    _createElementVNode("button", {
                                      type: "button",
                                      class: "settings-icon-btn",
                                      onClick: _cache[11] || (_cache[11] = ($event: any) => (editField('fees_minimum'))),
                                      disabled: ""
                                    }, [...(_cache[48] || (_cache[48] = [
                                      _createElementVNode("em", { class: "fas fa-ban" }, null, -1)
                                    ]))])
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_42, [
                                  _createElementVNode("label", _hoisted_43, _toDisplayString(_ctx.$t('settings.fees.fields.multiplier')), 1),
                                  _createElementVNode("div", _hoisted_44, [
                                    _withDirectives(_createElementVNode("input", {
                                      type: "number",
                                      class: "settings-fee-input",
                                      disabled: "",
                                      "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_unref(rideFees).fee_multiplier) = $event))
                                    }, null, 512), [
                                      [_vModelText, _unref(rideFees).fee_multiplier]
                                    ]),
                                    _createElementVNode("button", {
                                      type: "button",
                                      class: "settings-icon-btn",
                                      onClick: _cache[13] || (_cache[13] = ($event: any) => (editField('fee_multiplier'))),
                                      disabled: ""
                                    }, [...(_cache[49] || (_cache[49] = [
                                      _createElementVNode("em", { class: "fas fa-ban" }, null, -1)
                                    ]))])
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_45, [
                                  _createElementVNode("label", _hoisted_46, _toDisplayString(_ctx.$t('common.settings.fees_night')), 1),
                                  _createElementVNode("div", _hoisted_47, [
                                    _withDirectives(_createElementVNode("input", {
                                      type: "number",
                                      class: "settings-fee-input",
                                      disabled: fieldEdited.value !== 'fees_night' || allFieldsDisabled.value,
                                      "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_unref(rideFees).fees_night) = $event))
                                    }, null, 8, _hoisted_48), [
                                      [_vModelText, _unref(rideFees).fees_night]
                                    ]),
                                    _createElementVNode("button", {
                                      type: "button",
                                      class: "settings-icon-btn",
                                      onClick: _cache[15] || (_cache[15] = ($event: any) => (editField('fees_night'))),
                                      disabled: fieldEdited.value === 'fees_night'
                                    }, [...(_cache[50] || (_cache[50] = [
                                      _createElementVNode("em", { class: "fas fa-pencil" }, null, -1)
                                    ]))], 8, _hoisted_49)
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_50, [
                                  _createElementVNode("label", _hoisted_51, _toDisplayString(_ctx.$t('common.settings.fees_DxF')), 1),
                                  _createElementVNode("div", _hoisted_52, [
                                    _withDirectives(_createElementVNode("input", {
                                      type: "number",
                                      class: "settings-fee-input",
                                      disabled: fieldEdited.value !== 'fees_DxF' || allFieldsDisabled.value,
                                      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_unref(rideFees).fees_DxF) = $event))
                                    }, null, 8, _hoisted_53), [
                                      [_vModelText, _unref(rideFees).fees_DxF]
                                    ]),
                                    _createElementVNode("button", {
                                      type: "button",
                                      class: "settings-icon-btn",
                                      onClick: _cache[17] || (_cache[17] = ($event: any) => (editField('fees_DxF'))),
                                      disabled: fieldEdited.value === 'fees_DxF'
                                    }, [...(_cache[51] || (_cache[51] = [
                                      _createElementVNode("em", { class: "fas fa-pencil" }, null, -1)
                                    ]))], 8, _hoisted_54)
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_55, [
                                  _createElementVNode("label", _hoisted_56, _toDisplayString(_ctx.$t('common.settings.fees_night_DxF')), 1),
                                  _createElementVNode("div", _hoisted_57, [
                                    _withDirectives(_createElementVNode("input", {
                                      type: "number",
                                      class: "settings-fee-input",
                                      disabled: fieldEdited.value !== 'fees_night_DxF' || allFieldsDisabled.value,
                                      "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_unref(rideFees).fees_night_DxF) = $event))
                                    }, null, 8, _hoisted_58), [
                                      [_vModelText, _unref(rideFees).fees_night_DxF]
                                    ]),
                                    _createElementVNode("button", {
                                      type: "button",
                                      class: "settings-icon-btn",
                                      onClick: _cache[19] || (_cache[19] = ($event: any) => (editField('fees_night_DxF'))),
                                      disabled: fieldEdited.value === 'fees_night_DxF'
                                    }, [...(_cache[52] || (_cache[52] = [
                                      _createElementVNode("em", { class: "fas fa-pencil" }, null, -1)
                                    ]))], 8, _hoisted_59)
                                  ])
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_60, [
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "settings-primary-btn",
                                  onClick: updateAllFields,
                                  disabled: !submitButtonEnabled.value || updatingRideFees.value
                                }, [
                                  (updatingRideFees.value)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_62))
                                    : _createCommentVNode("", true),
                                  _createTextVNode(" " + _toDisplayString(_ctx.$t('common.actions.submit')), 1)
                                ], 8, _hoisted_61)
                              ])
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_63, [
                  _createElementVNode("div", _hoisted_64, [
                    _createElementVNode("div", _hoisted_65, [
                      _cache[53] || (_cache[53] = _createElementVNode("span", { class: "settings-icon-chip settings-icon-chip--info" }, [
                        _createElementVNode("em", { class: "fas fa-gauge-high" })
                      ], -1)),
                      _createElementVNode("h6", _hoisted_66, _toDisplayString(_ctx.$t('common.settings.dynamic_min_fee')), 1)
                    ]),
                    _createElementVNode("div", _hoisted_67, [
                      (_unref(rideFees))
                        ? (_openBlock(), _createBlock(_unref(Form), { key: 0 }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_68, [
                                _createElementVNode("div", _hoisted_69, [
                                  _createElementVNode("label", _hoisted_70, _toDisplayString(_ctx.$t('common.settings.fees_minimum_day')), 1),
                                  _createElementVNode("div", _hoisted_71, [
                                    _withDirectives(_createElementVNode("input", {
                                      type: "number",
                                      class: "settings-fee-input",
                                      disabled: fieldEdited.value !== 'price_kilometer' || allFieldsDisabled.value,
                                      "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_unref(rideFees).fees_min_day) = $event))
                                    }, null, 8, _hoisted_72), [
                                      [_vModelText, _unref(rideFees).fees_min_day]
                                    ]),
                                    _createElementVNode("button", {
                                      type: "button",
                                      class: "settings-icon-btn",
                                      onClick: _cache[21] || (_cache[21] = ($event: any) => (editField('price_kilometer'))),
                                      disabled: fieldEdited.value === 'price_kilometer'
                                    }, [...(_cache[54] || (_cache[54] = [
                                      _createElementVNode("em", { class: "fas fa-pencil" }, null, -1)
                                    ]))], 8, _hoisted_73)
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_74, [
                                  _createElementVNode("label", _hoisted_75, _toDisplayString(_ctx.$t('common.settings.fees_minimum_nigth')), 1),
                                  _createElementVNode("div", _hoisted_76, [
                                    _withDirectives(_createElementVNode("input", {
                                      type: "number",
                                      class: "settings-fee-input",
                                      disabled: fieldEdited.value !== 'price_minute' || allFieldsDisabled.value,
                                      "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_unref(rideFees).fees_min_nigth) = $event))
                                    }, null, 8, _hoisted_77), [
                                      [_vModelText, _unref(rideFees).fees_min_nigth]
                                    ]),
                                    _createElementVNode("button", {
                                      type: "button",
                                      class: "settings-icon-btn",
                                      onClick: _cache[23] || (_cache[23] = ($event: any) => (editField('price_minute'))),
                                      disabled: fieldEdited.value === 'price_minute'
                                    }, [...(_cache[55] || (_cache[55] = [
                                      _createElementVNode("em", { class: "fas fa-pencil" }, null, -1)
                                    ]))], 8, _hoisted_78)
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_79, [
                                  _createElementVNode("label", _hoisted_80, _toDisplayString(_ctx.$t('common.settings.fees_minimum_festive')), 1),
                                  _createElementVNode("div", _hoisted_81, [
                                    _withDirectives(_createElementVNode("input", {
                                      type: "number",
                                      class: "settings-fee-input",
                                      disabled: fieldEdited.value !== 'fees_base' || allFieldsDisabled.value,
                                      "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_unref(rideFees).fees_min_festive_day) = $event))
                                    }, null, 8, _hoisted_82), [
                                      [_vModelText, _unref(rideFees).fees_min_festive_day]
                                    ]),
                                    _createElementVNode("button", {
                                      type: "button",
                                      class: "settings-icon-btn",
                                      onClick: _cache[25] || (_cache[25] = ($event: any) => (editField('fees_base'))),
                                      disabled: fieldEdited.value === 'fees_base'
                                    }, [...(_cache[56] || (_cache[56] = [
                                      _createElementVNode("em", { class: "fas fa-pencil" }, null, -1)
                                    ]))], 8, _hoisted_83)
                                  ])
                                ]),
                                _createElementVNode("div", _hoisted_84, [
                                  _createElementVNode("label", _hoisted_85, _toDisplayString(_ctx.$t('common.settings.fees_minimum_festive_nigth')), 1),
                                  _createElementVNode("div", _hoisted_86, [
                                    _withDirectives(_createElementVNode("input", {
                                      type: "number",
                                      class: "settings-fee-input",
                                      disabled: fieldEdited.value !== 'fees_additional' || allFieldsDisabled.value,
                                      "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_unref(rideFees).fees_min_festive_nigth) = $event))
                                    }, null, 8, _hoisted_87), [
                                      [_vModelText, _unref(rideFees).fees_min_festive_nigth]
                                    ]),
                                    _createElementVNode("button", {
                                      type: "button",
                                      class: "settings-icon-btn",
                                      onClick: _cache[27] || (_cache[27] = ($event: any) => (editField('fees_additional'))),
                                      disabled: fieldEdited.value === 'fees_additional'
                                    }, [...(_cache[57] || (_cache[57] = [
                                      _createElementVNode("em", { class: "fas fa-pencil" }, null, -1)
                                    ]))], 8, _hoisted_88)
                                  ])
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_89, [
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "settings-primary-btn",
                                  onClick: updateAllFields,
                                  disabled: !submitButtonEnabled.value || updatingRideFees.value
                                }, [
                                  (updatingRideFees.value)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_91))
                                    : _createCommentVNode("", true),
                                  _createTextVNode(" " + _toDisplayString(_ctx.$t('common.actions.submit')), 1)
                                ], 8, _hoisted_90)
                              ])
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_92, [
                  _createElementVNode("div", _hoisted_93, [
                    _createElementVNode("div", _hoisted_94, [
                      _cache[58] || (_cache[58] = _createElementVNode("span", { class: "settings-icon-chip settings-icon-chip--primary" }, [
                        _createElementVNode("em", { class: "fas fa-stopwatch" })
                      ], -1)),
                      _createElementVNode("h6", _hoisted_95, _toDisplayString(_ctx.$t('common.settings.self_service_cancel_window_title')), 1)
                    ]),
                    _createElementVNode("div", _hoisted_96, [
                      (_unref(rideFees))
                        ? (_openBlock(), _createBlock(_unref(Form), { key: 0 }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_97, [
                                _createElementVNode("div", _hoisted_98, [
                                  _createElementVNode("label", _hoisted_99, _toDisplayString(_ctx.$t('common.settings.self_service_cancel_window')), 1),
                                  _createElementVNode("div", _hoisted_100, [
                                    _withDirectives(_createElementVNode("input", {
                                      type: "number",
                                      class: "settings-fee-input",
                                      min: "1",
                                      step: "1",
                                      disabled: fieldEdited.value !== 'self_service_cancel_window' || allFieldsDisabled.value,
                                      "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => ((_unref(rideFees).self_service_cancel_window) = $event))
                                    }, null, 8, _hoisted_101), [
                                      [_vModelText, _unref(rideFees).self_service_cancel_window]
                                    ]),
                                    _createElementVNode("button", {
                                      type: "button",
                                      class: "settings-icon-btn",
                                      onClick: _cache[29] || (_cache[29] = ($event: any) => (editField('self_service_cancel_window'))),
                                      disabled: fieldEdited.value === 'self_service_cancel_window'
                                    }, [...(_cache[59] || (_cache[59] = [
                                      _createElementVNode("em", { class: "fas fa-pencil" }, null, -1)
                                    ]))], 8, _hoisted_102)
                                  ]),
                                  _createElementVNode("small", _hoisted_103, _toDisplayString(_ctx.$t('common.settings.self_service_cancel_window_hint')), 1)
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_104, [
                                _createElementVNode("button", {
                                  type: "button",
                                  class: "settings-primary-btn",
                                  onClick: updateAllFields,
                                  disabled: !submitButtonEnabled.value || updatingRideFees.value
                                }, [
                                  (updatingRideFees.value)
                                    ? (_openBlock(), _createElementBlock("span", _hoisted_106))
                                    : _createCommentVNode("", true),
                                  _createTextVNode(" " + _toDisplayString(_ctx.$t('common.actions.submit')), 1)
                                ], 8, _hoisted_105)
                              ])
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_107, [
                _createElementVNode("div", _hoisted_108, [
                  _cache[61] || (_cache[61] = _createElementVNode("span", { class: "settings-icon-chip settings-icon-chip--warning" }, [
                    _createElementVNode("em", { class: "fas fa-clock" })
                  ], -1)),
                  _createElementVNode("h6", _hoisted_109, _toDisplayString(_ctx.$t('common.settings.dynamic_multiplier_fee')), 1),
                  _createElementVNode("button", _hoisted_110, [
                    _cache[60] || (_cache[60] = _createElementVNode("em", { class: "fas fa-plus" }, null, -1)),
                    _createTextVNode(" " + _toDisplayString(_ctx.$t('common.settings.add_time_slot')), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_111, [
                  (_unref(rideFees))
                    ? (_openBlock(), _createElementBlock("div", _hoisted_112, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(rideFees).dynamic_multipliers, (multiplier, index) => {
                          return (_openBlock(), _createElementBlock("div", {
                            class: "settings-multiplier-row",
                            key: index
                          }, [
                            _createElementVNode("div", _hoisted_113, [
                              _createElementVNode("div", _hoisted_114, [
                                _createElementVNode("span", _hoisted_115, _toDisplayString(multiplier.name), 1),
                                _createElementVNode("span", _hoisted_116, _toDisplayString(multiplier.multiplier), 1)
                              ]),
                              _createElementVNode("div", _hoisted_117, [
                                _createElementVNode("span", _hoisted_118, _toDisplayString(_ctx.$t('common.settings.hour_range')), 1),
                                _withDirectives(_createElementVNode("input", {
                                  type: "time",
                                  class: "settings-time-input",
                                  "onUpdate:modelValue": ($event: any) => ((multiplier.timeRanges.start) = $event)
                                }, null, 8, _hoisted_119), [
                                  [_vModelText, multiplier.timeRanges.start]
                                ]),
                                _cache[62] || (_cache[62] = _createElementVNode("span", { class: "settings-multiplier-sep" }, "–", -1)),
                                _withDirectives(_createElementVNode("input", {
                                  type: "time",
                                  class: "settings-time-input",
                                  "onUpdate:modelValue": ($event: any) => ((multiplier.timeRanges.end) = $event)
                                }, null, 8, _hoisted_120), [
                                  [_vModelText, multiplier.timeRanges.end]
                                ])
                              ])
                            ]),
                            _createElementVNode("button", {
                              type: "button",
                              class: "settings-icon-btn settings-icon-btn--danger",
                              onClick: ($event: any) => (removeMultiplier(index)),
                              disabled: !!removingMultiplier.value[index]
                            }, [
                              (removingMultiplier.value[index])
                                ? (_openBlock(), _createElementBlock("span", _hoisted_122))
                                : (_openBlock(), _createElementBlock("em", _hoisted_123))
                            ], 8, _hoisted_121)
                          ]))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ])),
        _createVNode(CreateMultiplierModal)
      ]),
      _createElementVNode("div", _hoisted_124, [
        (currentTab.value === 'messages')
          ? (_openBlock(), _createBlock(SettingsMsg, { key: 0 }))
          : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_125, [
        (monthlyPaymentSettingsLoading.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_126, [...(_cache[63] || (_cache[63] = [
              _createElementVNode("span", {
                class: "spinner-border",
                role: "status",
                "aria-hidden": "true"
              }, null, -1)
            ]))]))
          : (monthlyPaymentSettings.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_127, [
                _createElementVNode("div", _hoisted_128, [
                  _createElementVNode("div", _hoisted_129, [
                    _createElementVNode("div", _hoisted_130, [
                      _cache[64] || (_cache[64] = _createElementVNode("span", { class: "settings-icon-chip settings-icon-chip--primary" }, [
                        _createElementVNode("em", { class: "fas fa-calendar-check" })
                      ], -1)),
                      _createElementVNode("h6", _hoisted_131, _toDisplayString(_ctx.$t('settings.monthly_payments.panel_title')), 1)
                    ]),
                    _createElementVNode("div", _hoisted_132, [
                      _createElementVNode("p", _hoisted_133, _toDisplayString(_ctx.$t('settings.monthly_payments.panel_subtitle')), 1),
                      _createElementVNode("div", _hoisted_134, [
                        _createElementVNode("label", _hoisted_135, _toDisplayString(_ctx.$t('settings.monthly_payments.field_suggested_amount')), 1),
                        _createElementVNode("div", _hoisted_136, [
                          _withDirectives(_createElementVNode("input", {
                            ref_key: "suggestedAmountInputEl",
                            ref: suggestedAmountInputEl,
                            type: "number",
                            class: "settings-fee-input",
                            "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => ((monthlyPaymentSettings.value.suggested_amount) = $event)),
                            min: "0"
                          }, null, 512), [
                            [
                              _vModelText,
                              monthlyPaymentSettings.value.suggested_amount,
                              void 0,
                              { number: true }
                            ]
                          ]),
                          _createElementVNode("button", {
                            type: "button",
                            class: "settings-icon-btn",
                            onClick: _cache[31] || (_cache[31] = ($event: any) => (suggestedAmountInputEl.value?.focus()))
                          }, [...(_cache[65] || (_cache[65] = [
                            _createElementVNode("em", { class: "fas fa-pencil" }, null, -1)
                          ]))])
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_137, [
                        _createElementVNode("label", _hoisted_138, _toDisplayString(_ctx.$t('settings.monthly_payments.field_cutoff_day')), 1),
                        _createElementVNode("div", _hoisted_139, [
                          _withDirectives(_createElementVNode("input", {
                            ref_key: "cutoffDayInputEl",
                            ref: cutoffDayInputEl,
                            type: "number",
                            class: "settings-fee-input",
                            "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => ((monthlyPaymentSettings.value.cutoff_day) = $event)),
                            min: "1",
                            max: "28"
                          }, null, 512), [
                            [
                              _vModelText,
                              monthlyPaymentSettings.value.cutoff_day,
                              void 0,
                              { number: true }
                            ]
                          ]),
                          _createElementVNode("button", {
                            type: "button",
                            class: "settings-icon-btn",
                            onClick: _cache[33] || (_cache[33] = ($event: any) => (cutoffDayInputEl.value?.focus()))
                          }, [...(_cache[66] || (_cache[66] = [
                            _createElementVNode("em", { class: "fas fa-pencil" }, null, -1)
                          ]))])
                        ]),
                        _createElementVNode("small", _hoisted_140, _toDisplayString(_ctx.$t('settings.monthly_payments.hint_cutoff_day')), 1)
                      ]),
                      _createElementVNode("div", _hoisted_141, [
                        _createElementVNode("label", _hoisted_142, _toDisplayString(_ctx.$t('settings.monthly_payments.field_reminder_offsets')), 1),
                        _createElementVNode("div", _hoisted_143, [
                          _createElementVNode("input", {
                            ref_key: "reminderOffsetsInputEl",
                            ref: reminderOffsetsInputEl,
                            type: "text",
                            class: "settings-fee-input",
                            value: monthlyPaymentSettings.value.reminder_offsets.join(', '),
                            onChange: onReminderOffsetsChange
                          }, null, 40, _hoisted_144),
                          _createElementVNode("button", {
                            type: "button",
                            class: "settings-icon-btn",
                            onClick: _cache[34] || (_cache[34] = ($event: any) => (reminderOffsetsInputEl.value?.focus()))
                          }, [...(_cache[67] || (_cache[67] = [
                            _createElementVNode("em", { class: "fas fa-pencil" }, null, -1)
                          ]))])
                        ]),
                        (reminderOffsetWarning.value)
                          ? (_openBlock(), _createElementBlock("small", _hoisted_145, _toDisplayString(reminderOffsetWarning.value), 1))
                          : (_openBlock(), _createElementBlock("small", _hoisted_146, _toDisplayString(_ctx.$t('settings.monthly_payments.hint_reminder_offsets')), 1))
                      ]),
                      _createElementVNode("div", _hoisted_147, [
                        _createElementVNode("div", _hoisted_148, [
                          _withDirectives(_createElementVNode("input", {
                            class: "form-check-input",
                            type: "checkbox",
                            id: "auto-disable-switch",
                            "onUpdate:modelValue": _cache[35] || (_cache[35] = ($event: any) => ((monthlyPaymentSettings.value.auto_disable) = $event))
                          }, null, 512), [
                            [_vModelCheckbox, monthlyPaymentSettings.value.auto_disable]
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_149, [
                          _createElementVNode("label", _hoisted_150, _toDisplayString(_ctx.$t('settings.monthly_payments.field_auto_disable')), 1),
                          _createElementVNode("small", _hoisted_151, _toDisplayString(_ctx.$t('settings.monthly_payments.hint_auto_disable')), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_152, [
                        _createElementVNode("button", {
                          type: "button",
                          class: "settings-primary-btn",
                          onClick: saveMonthlyPaymentSettings,
                          disabled: savingMonthlyPaymentSettings.value
                        }, [
                          (savingMonthlyPaymentSettings.value)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_154))
                            : _createCommentVNode("", true),
                          _createTextVNode(" " + _toDisplayString(_ctx.$t('common.actions.submit')), 1)
                        ], 8, _hoisted_153)
                      ])
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true)
      ]),
      _createElementVNode("div", _hoisted_155, [
        _createElementVNode("div", _hoisted_156, [
          _createElementVNode("div", _hoisted_157, [
            _cache[68] || (_cache[68] = _createElementVNode("span", { class: "settings-icon-chip settings-icon-chip--info" }, [
              _createElementVNode("em", { class: "fas fa-city" })
            ], -1)),
            _createElementVNode("h6", _hoisted_158, _toDisplayString(_ctx.$t('common.settings.branches')), 1)
          ]),
          _createElementVNode("div", _hoisted_159, [
            _createElementVNode("div", _hoisted_160, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(branches), (branch) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "col-12 col-lg-6 mb-3",
                  key: branch.id
                }, [
                  _createElementVNode("div", _hoisted_161, [
                    _createElementVNode("div", _hoisted_162, [
                      _createElementVNode("span", _hoisted_163, [
                        (countryFlag(branch.country))
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              _createTextVNode(_toDisplayString(countryFlag(branch.country)), 1)
                            ], 64))
                          : (_openBlock(), _createElementBlock("em", _hoisted_164))
                      ]),
                      _createElementVNode("div", _hoisted_165, [
                        _createElementVNode("div", _hoisted_166, _toDisplayString(branch.country), 1),
                        _createElementVNode("div", _hoisted_167, [
                          _createElementVNode("div", _hoisted_168, [
                            _createElementVNode("span", _hoisted_169, _toDisplayString(_ctx.$t('common.settings.calling_code')), 1),
                            _createElementVNode("span", _hoisted_170, _toDisplayString(branch.calling_code), 1)
                          ]),
                          _createElementVNode("div", _hoisted_171, [
                            _createElementVNode("span", _hoisted_172, _toDisplayString(_ctx.$t('common.settings.currency_code')), 1),
                            _createElementVNode("span", _hoisted_173, _toDisplayString(branch.currency_code), 1)
                          ])
                        ])
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_174, _toDisplayString(_ctx.$t('common.settings.cities')), 1),
                    _createElementVNode("div", _hoisted_175, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(branch.cities, (city) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "settings-city-row",
                          key: city.id
                        }, [
                          _createElementVNode("div", _hoisted_176, [
                            _createElementVNode("input", {
                              type: "checkbox",
                              class: "form-check-input",
                              role: "switch",
                              onClick: ($event: any) => (_unref(setBranchSelected)(branch, city)),
                              checked: _unref(branchSelected)?.city.id === city.id,
                              id: city.id
                            }, null, 8, _hoisted_177)
                          ]),
                          _createElementVNode("label", {
                            class: "settings-city-name",
                            for: city.id
                          }, _toDisplayString(city.name), 9, _hoisted_178),
                          _createElementVNode("div", _hoisted_179, [
                            _createElementVNode("span", _hoisted_180, _toDisplayString(_ctx.$t('common.placeholders.current_percentage')), 1),
                            _createElementVNode("span", _hoisted_181, _toDisplayString(city.percentage) + "%", 1)
                          ]),
                          (_unref(AuthService).isAdmin())
                            ? (_openBlock(), _createElementBlock("button", {
                                key: 0,
                                type: "button",
                                class: "settings-icon-btn",
                                "data-bs-target": "#percentage-modal",
                                "data-bs-toggle": "modal",
                                onClick: ($event: any) => (selectBranch(branch, city))
                              }, [...(_cache[69] || (_cache[69] = [
                                _createElementVNode("em", { class: "fas fa-pencil" }, null, -1)
                              ]))], 8, _hoisted_182))
                            : _createCommentVNode("", true)
                        ]))
                      }), 128))
                    ])
                  ])
                ]))
              }), 128))
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_183, [
        _createElementVNode("div", _hoisted_184, [
          _createElementVNode("div", _hoisted_185, [
            _createElementVNode("div", _hoisted_186, [
              _createElementVNode("h5", _hoisted_187, _toDisplayString(_ctx.$t('common.actions.set_percentage')), 1),
              _cache[70] || (_cache[70] = _createElementVNode("button", {
                type: "button",
                class: "btn-close",
                "data-bs-dismiss": "modal",
                "aria-label": "Close"
              }, [
                _createElementVNode("span", { "aria-hidden": "true" }, "×")
              ], -1))
            ]),
            _createElementVNode("div", _hoisted_188, [
              _createElementVNode("div", _hoisted_189, [
                _createElementVNode("label", _hoisted_190, _toDisplayString(_ctx.$t('common.placeholders.current_percentage')), 1),
                _createElementVNode("span", _hoisted_191, _toDisplayString(_unref(citySelected).percentage + '%'), 1)
              ]),
              _createElementVNode("div", _hoisted_192, [
                _createElementVNode("label", _hoisted_193, _toDisplayString(_ctx.$t('common.actions.set_percentage')), 1),
                _withDirectives(_createElementVNode("input", {
                  type: "number",
                  class: "settings-fee-input",
                  "onUpdate:modelValue": _cache[36] || (_cache[36] = ($event: any) => ((_unref(citySelected).percentage) = $event))
                }, null, 512), [
                  [_vModelText, _unref(citySelected).percentage]
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_194, [
              _createElementVNode("button", _hoisted_195, _toDisplayString(_ctx.$t('common.actions.close')), 1),
              _createElementVNode("button", {
                onClick: _cache[37] || (_cache[37] = ($event: any) => (setPercentageModal(_unref(citySelected), _unref(branch).id))),
                type: "button",
                "data-bs-dismiss": "modal",
                class: "settings-primary-btn",
                disabled: submittingPercentage.value
              }, [
                (submittingPercentage.value)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_197))
                  : _createCommentVNode("", true),
                _createTextVNode(" " + _toDisplayString(_ctx.$t('common.actions.submit')), 1)
              ], 8, _hoisted_196)
            ])
          ])
        ])
      ])
    ])
  ]))
}
}

})